<template>
  <div class="row">
    <div class="col-lg-12 col-md-12">
      <card class="shadow-lg">
        <div class="row content-add-btn">
          <button class="btn btn-secondary" @click="$router.go(-1)">
            <em class="fa fa-chevron-left"></em>
            {{ $t('common_words.exit') }}
          </button>
        </div>
        <hr />
        <form-wizard
          ref="formWizard"
          v-if="this.isCreate() || this.isUpdate()"
          @on-complete="addClientsForm"
          title
          subtitle
          :back-button-text="$t('common_words.back')"
          :next-button-text="$t('common_words.next')"
          :finish-button-text="$t('common_words.save')"
          class="custom-padding-wz-header"
        >
          <tab-content
            :title="$t('common_words.general_information')"
            :before-change="() => validateStep('firstStep')"
          >
            <first-step
              ref="firstStep"
              @on-validated="onStepValidated"
              @showHideLoading="showHideLoading"
            ></first-step>
          </tab-content>
          <tab-content
            :title="$t('common_words.location')"
            :before-change="() => validateStep('secondStep')"
          >
            <second-step
              ref="secondStep"
              @on-validated="onStepValidated"
              @showHideLoading="showHideLoading"
            ></second-step>
          </tab-content>
          <tab-content :title="$t('common_words.confirm')">
            <p class="cm-mg-p-wzd text-center">
              3.1 {{ $t('common_words.verify_inputed_information') }}
            </p>
            <br />
            <div class="row d-flex justify-content-center">
              <div class="col-8">
                <client-details-table :clientData="clientsForm" />
              </div>
            </div>
          </tab-content>
        </form-wizard>
        <not-index-permissions v-else :operationType="'operation'" />
      </card>
    </div>
  </div>
</template>
<script>
import { Axios } from 'src/class/Axios.js';
import { isset } from 'src/util/Util.js';
import { showContinue } from 'src/util/Util.js';
import ClientTableDetails from './ClientTableDetails.vue';
import FirstStep from './steps/FirstStep.vue';
import mixinMasters from 'src/util/mixinMasters';
import MixinMenu from 'src/util/mixinMenu';
import MixinPermissions from 'src/util/mixinPermissions';
import SecondStep from './steps/SecondStep.vue';

export default {
  components: {
    [ClientTableDetails.name]: ClientTableDetails,
    FirstStep,
    SecondStep,
  },
  data() {
    return {
      clientsForm: {},
    };
  },
  mixins: [MixinPermissions, mixinMasters, MixinMenu],

  methods: {
    cleanAllSteps() {
      this.$refs.firstStep.model = { ...this.$refs.firstStep.initialModel };
      this.$refs.secondStep.model = { ...this.$refs.secondStep.initialModel };
    },

    validateStep(ref) {
      return this.$refs[ref].validate();
    },

    onStepValidated(_, model) {
      this.clientsForm = { ...this.clientsForm, ...model };
    },

    addClientsForm() {
      this.showHideLoading(true);
      this.clientsForm.route = 'pqrs/clients';
      if (sessionStorage.getItem('editForm')) {
        if (this.isUpdate()) {
          const editForm = {
            ...JSON.parse(sessionStorage.getItem('editForm')),
          };
          this.clientsForm.id = editForm.id;
          Axios.updateMaster(this.clientsForm)
            .then((response) => {
              this.showHideLoading();
              showContinue(
                this,
                response.data.message ? response.data.message : response.errors,
                '/pqrs/clients',
                null
              );
            })
            .catch((error) => this.showMessageErrors(error));
        } else {
          this.showMessageAccess();
          this.showHideLoading();
        }
      } else {
        if (this.isCreate()) {
          Axios.saveMaster(this.clientsForm)
            .then((response) => {
              this.showHideLoading();
              showContinue(
                this,
                response.data.message ? response.data.message : response.errors,
                '/pqrs/clients',
                null
              );
            })
            .catch((error) => this.showMessageErrors(error));
        } else {
          this.showMessageAccess();
          this.showHideLoading();
        }
      }
    },

    isSet(data) {
      return isset(data);
    },
  },

  mounted() {
    this.selectedItemOnMenu('pqrs');
  },

  beforeDestroy() {
    sessionStorage.removeItem('editForm');
    this.deselectedItemOnMenu('pqrs');
  },
};
</script>
